var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.metadata['icon'])?_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(" "+_vm._s(_vm.metadata["icon"])+" ")]):_vm._e(),_c('router-link',{attrs:{"to":_vm.path()}},[_vm._v(_vm._s(_vm.cellText()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }